<template>
  <!-- 自定义名称
       @author: liuguisheng
       @date: 2019-10-22
   -->
  <div class="setting-item">
    <el-form-item label="自定义名称"> 
      <el-input type="text" 
                v-model="customName"
                clearable
                placeholder="请输入自定义名称"></el-input>
    </el-form-item>
  </div>
</template>

<script>
// 导入value监听混入
import mixValueWatch from '@/mixins/common/mix_value_watch.js';
// 导入计算属性映射方法
import { mapComputed } from '@/mixins/common/mix_value_watch.js';
export default {
  mixins: [ mixValueWatch ],
  computed: {
    /** @name 基础属性-自定义名称
     *  @description 将 customName 字段映射到当前 customName 计算属性
     *  @return { String }
     *  @author liuguisheng
     *  @version 2019-10-22
     */
    ...mapComputed({
      customName: { 
        parent: i => i.baseOption,
        attr: "customName" 
      }
    }),
  },
}
</script>


// WEBPACK FOOTER //
// src/components/Setting/base_setting/SettingCustomName.vue